import React from 'react';
import { Camera, ArrowRight, Heart } from 'lucide-react';

export default function ShareMyPartyPicsPromo() {
  return (
    <section className="py-20 lg:py-28 bg-gradient-to-b from-[#FBF7F2] via-[#F5E9F5] to-[#FBF7F2]">
      <div className="max-w-6xl mx-auto px-6 lg:px-10">
        <div className="soft-card rounded-[2rem] overflow-hidden bg-white relative">
          <div className="grid grid-cols-1 lg:grid-cols-5 items-center">
            <div className="lg:col-span-3 p-8 lg:p-14">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-medium mb-5"
                style={{ background: '#F4E7FA', color: '#7B2C7B' }}>
                <Heart className="w-3.5 h-3.5" />
                From the same makers
              </div>
              <h2 className="font-serif text-4xl lg:text-5xl text-[#2A2A2A] leading-tight">
                Every guest. Every photo.<br />
                <span className="italic" style={{ color: '#A639C8' }}>One shared album.</span>
              </h2>
              <p className="mt-5 text-[#4A4A4A] text-lg leading-relaxed max-w-lg">
                Stop chasing your wedding photos in seven different group chats. ShareMyPartyPics gives every guest a single QR code at your wedding — and every photo they snap lands in one beautiful, private album. Yours forever.
              </p>

              <ul className="mt-6 space-y-3 text-[#3A3A3A]">
                {[
                  'One QR code, every guest, zero apps to install',
                  'Live album that fills up as the night unfolds',
                  'Private, password-protected, ad-free',
                  'Download every full-res photo the morning after',
                ].map((t, i) => (
                  <li key={i} className="flex items-start gap-3 text-sm">
                    <Camera className="w-4 h-4 mt-0.5 flex-shrink-0" style={{ color: '#A639C8' }} />
                    {t}
                  </li>
                ))}
              </ul>

              <div className="mt-8 flex flex-wrap items-center gap-4">
                <a
                  href="https://sharemypartypics.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-full text-sm font-medium text-white transition-all"
                  style={{ background: 'linear-gradient(90deg, #4A1FA9 0%, #C8377E 100%)' }}
                >
                  Visit ShareMyPartyPics
                  <ArrowRight className="w-4 h-4" />
                </a>
                <span className="text-xs text-[#6A6A6A]">Launching soon · Get on the early-bird list</span>
              </div>
            </div>

            <div className="lg:col-span-2 p-8 lg:p-10 flex items-center justify-center bg-gradient-to-br from-[#F4E7FA] to-[#FCEAF1]">
              <div className="relative w-full max-w-xs">
                <img
                  src="/images/smpp-logo.png"
                  alt="Share My Party Pics"
                  className="w-full h-auto rounded-2xl shadow-xl"
                />
                <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 px-3 py-1.5 rounded-full bg-white shadow-md text-xs font-medium text-[#7B2C3B] whitespace-nowrap">
                  sharemypartypics.com
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
